/* Philip Watches offer adapter. Shopify remains the authority for stock and discounts. */
(() => {
  'use strict';
  const init = (section) => {
    if (section.dataset.pwPairReady) return;
    section.dataset.pwPairReady = 'true';
    const selected = new Map();
    const dialog = section.querySelector('[data-pw-pair-dialog]');
    const review = section.querySelector('[data-pw-pair-review]');
    const status = section.querySelector('[data-pw-pair-status]');
    const complete = section.querySelector('[data-final-set-complete]');
    const bar = section.querySelector('[data-final-set-bar]');
    const add = section.querySelector('[data-pw-pair-add]');
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    const originalPhotos = new WeakMap();
    let busy = false;
    let trigger;
    let priorOverflow = '';
    let attempt;

    const node = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    };
    const cardData = (card) => {
      try { return JSON.parse(card.querySelector('[data-final-set-product-json]').textContent); }
      catch { return null; }
    };
    const announce = (message) => {
      section.querySelector('[data-config-status]').textContent = message;
    };
    const syncVariantPhoto = (card, data = cardData(card)) => {
      const select = card.querySelector('[data-final-set-variant]');
      const variant = data?.variants.find(item => String(item.id) === select.value);
      card.querySelectorAll('[data-pw-variant-choice]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.pwVariantChoice === select.value));
        button.disabled = busy || !data?.variants.find(item => String(item.id) === button.dataset.pwVariantChoice)?.available;
      });
      const shown = variant || data?.variants.find(item => item.available) || data?.variants[0];
      const now = card.querySelector('[data-final-set-now]');
      const was = card.querySelector('[data-final-set-was]');
      const save = card.querySelector('[data-final-set-save]');
      if (shown && now) {
        now.textContent = shown.priceText;
        was.hidden = !shown.compareText;
        was.textContent = shown.compareText || '';
        save.hidden = !shown.saveText;
        save.textContent = shown.saveText ? 'Save ' + shown.saveText : '';
      }
      const image = card.querySelector('.final-set-card__media img');
      if (image && !originalPhotos.has(image)) {
        originalPhotos.set(image, { src: image.getAttribute('src'), srcset: image.getAttribute('srcset'), alt: image.getAttribute('alt') });
      }
      if (image && variant?.image) {
        if (variant.imageSrcset) image.srcset = variant.imageSrcset;
        else image.removeAttribute('srcset');
        image.src = variant.image;
        image.alt = data.title + ' — ' + variant.title;
      } else if (image) {
        const original = originalPhotos.get(image);
        for (const [name, value] of Object.entries(original)) {
          if (value === null) image.removeAttribute(name);
          else image.setAttribute(name, value);
        }
      }
    };
    const renderItems = (host) => {
      host.replaceChildren();
      for (const [id, item] of selected) {
        const row = node('div', 'pw-pair-item');
        if (item.variant.image || item.image) {
          const image = node('img');
          image.src = item.variant.image || item.image;
          image.alt = '';
          image.width = 72;
          image.height = 72;
          row.append(image);
        }
        const details = node('div', 'pw-pair-item__copy');
        details.append(node('strong', '', item.title));
        if (item.variant.title !== 'Default Title') details.append(node('span', '', item.variant.title));
        row.append(details);
        const remove = node('button', 'pw-pair-remove', 'Remove');
        remove.type = 'button';
        remove.dataset.pwPairRemove = id;
        remove.setAttribute('aria-label', 'Remove ' + item.title);
        remove.disabled = busy;
        row.append(remove);
        host.append(row);
      }
    };
    const render = () => {
      const ids = [...selected.keys()];
      section.querySelectorAll('[data-final-set-product]').forEach(card => {
        const id = card.dataset.productId;
        const item = selected.get(id);
        const button = card.querySelector('[data-final-set-select]');
        const position = card.querySelector('[data-final-set-position]');
        const select = card.querySelector('[data-final-set-variant]');
        const data = cardData(card);
        const available = data?.variants.some(variant => variant.available);
        card.classList.toggle('is-selected', !!item);
        button.setAttribute('aria-pressed', String(!!item));
        button.disabled = busy || !available;
        button.textContent = item ? 'Selected ✓' : available ? 'Select Watch' : 'Sold out';
        position.hidden = !item;
        position.textContent = item ? String(ids.indexOf(id) + 1) : '';
        select.disabled = busy;
        if (item) select.value = String(item.variant.id);
        syncVariantPhoto(card, data);
      });
      section.querySelector('[data-final-set-progress]').textContent = selected.size + ' of 2';
      section.querySelector('[data-final-set-progress-track]').value = selected.size;
      section.querySelector('[data-final-set-status-title]').textContent = selected.size === 2 ? 'Your pair is ready' : 'Choose two watches';
      complete.disabled = busy || selected.size !== 2;
      complete.textContent = selected.size === 2 ? 'Review my pair' : 'Select two to continue';
      bar.hidden = selected.size === 0;
      const details = section.querySelector('[data-final-set-selected-review]');
      details.hidden = selected.size === 0;
      section.querySelector('[data-final-set-selected-count]').textContent = '(' + selected.size + '/2)';
      renderItems(section.querySelector('[data-final-set-selected-list]'));
      renderItems(review);
      add.disabled = busy || selected.size !== 2;
      add.textContent = busy ? 'Adding your watches…' : 'Add my pair to cart';
      section.querySelectorAll('[data-pw-pair-close]').forEach(button => { button.disabled = busy; });
    };
    const open = (from) => {
      if (selected.size !== 2 || busy) return;
      trigger = from || document.activeElement;
      status.textContent = '';
      render();
      if (!dialog.open) {
        priorOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
      add.focus();
    };
    const close = () => { if (!busy) dialog.close(); };
    dialog.addEventListener('close', () => {
      document.body.style.overflow = priorOverflow;
      if (trigger?.isConnected) trigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('cancel', (event) => { if (busy) event.preventDefault(); });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    section.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.hasAttribute('data-pw-pair-close')) { close(); return; }
      if (button.hasAttribute('data-final-set-complete')) { open(button); return; }
      if (button.hasAttribute('data-pw-variant-choice')) {
        if (busy) return;
        const select = button.closest('[data-final-set-product]').querySelector('[data-final-set-variant]');
        select.value = button.dataset.pwVariantChoice;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      if (button.hasAttribute('data-pw-pair-remove')) {
        if (busy) return;
        selected.delete(button.dataset.pwPairRemove);
        attempt = undefined;
        status.textContent = '';
        if (dialog.open) close();
        render();
        announce('Watch removed. Choose ' + (2 - selected.size) + ' more.');
        return;
      }
      if (!button.hasAttribute('data-final-set-select') || busy) return;
      const card = button.closest('[data-final-set-product]');
      const id = card.dataset.productId;
      if (selected.has(id)) {
        selected.delete(id);
        attempt = undefined;
        render();
        announce('Watch removed.');
        return;
      }
      if (selected.size === 2) { open(button); return; }
      const data = cardData(card);
      const select = card.querySelector('[data-final-set-variant]');
      const variant = data?.variants.find(item => String(item.id) === select.value && item.available);
      if (!variant) {
        select.setCustomValidity('Choose an available option.');
        const thumbnail = card.querySelector('[data-pw-variant-choice]:not(:disabled)');
        if (thumbnail) {
          announce('Choose an available color.');
          thumbnail.focus();
        } else {
          select.reportValidity();
          select.focus();
        }
        return;
      }
      selected.set(id, { ...data, variant });
      attempt = undefined;
      render();
      announce(data.title + ' selected. ' + selected.size + ' of 2 watches.');
      if (selected.size === 2) open(button);
    });
    section.addEventListener('change', (event) => {
      if (!event.target.matches('[data-final-set-variant]')) return;
      const select = event.target;
      select.setCustomValidity('');
      const card = select.closest('[data-final-set-product]');
      const id = card.dataset.productId;
      syncVariantPhoto(card);
      if (!selected.has(id)) return;
      const data = cardData(card);
      const variant = data.variants.find(item => String(item.id) === select.value && item.available);
      if (variant) selected.set(id, { ...data, variant });
      else selected.delete(id);
      attempt = undefined;
      render();
    });
    const json = async (path, payload) => {
      const response = await fetch(root + path, {
        method: payload ? 'POST' : 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json', ...(payload ? { 'Content-Type': 'application/json' } : {}) },
        ...(payload ? { body: JSON.stringify(payload) } : {}),
        signal: AbortSignal.timeout(20000)
      });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || data.message || 'Unable to update your bag. Please try again.');
      return data;
    };
    add.addEventListener('click', async () => {
      if (busy || selected.size !== 2) return;
      busy = true;
      status.textContent = '';
      attempt ||= crypto.randomUUID();
      const items = [...selected.values()].map(item => ({
        id: item.variant.id, quantity: 1, properties: { _pw_pair_attempt: attempt }
      }));
      render();
      try {
        const commit = async () => {
          // A network timeout may happen after Shopify accepted a request.
          // Reconcile the same attempt before retrying to prevent duplicate pairs.
          const cart = await json('cart.js');
          if (!Array.isArray(cart.items)) throw Error('Your bag could not be verified. Please refresh and try again.');
          const missing = items.filter(item => !cart.items.some(line =>
            String(line.variant_id) === String(item.id) && line.properties?._pw_pair_attempt === attempt
          ));
          if (missing.length) await json('cart/add.js', { items: missing });
        };
        if (window.EdviBag) await window.EdviBag.transact(commit);
        else await commit();
        busy = false;
        close();
        selected.clear();
        attempt = undefined;
        render();
        if (window.EdviBag) window.EdviBag.open(document.querySelector('[data-open-cart]') || complete);
        else location.assign(root + 'cart');
      } catch (failure) {
        busy = false;
        render();
        status.textContent = failure.name === 'TimeoutError' || failure.name === 'AbortError'
          ? 'The update took longer than expected. Retry to verify your bag before adding anything again.'
          : failure.message || 'Unable to add this pair. Check availability and try again.';
      }
    });
    section.addEventListener('edvi:collection-updated', render);
    render();
    const preselect = async () => {
      const params = new URL(location.href).searchParams;
      const handle = params.get('preselect');
      if (!handle || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
      try {
        const card = [...section.querySelectorAll('[data-final-set-product]')].find(item => item.dataset.productHandle === handle);
        let data = card && cardData(card);
        if (!data) {
          const config = JSON.parse(section.querySelector('[data-final-set-config]').textContent);
          const catalog = await json('collections/' + encodeURIComponent(config.collectionHandle) + '/products.json?limit=250');
          if (!catalog.products?.some(product => product.handle === handle)) return;
          const product = await json('products/' + encodeURIComponent(handle) + '.js');
          data = { ...product, productId: product.id, image: product.featured_image };
        }
        const variantId = params.get('preselect_variant');
        const variant = variantId
          ? data.variants.find(item => String(item.id) === variantId && item.available)
          : data.variants.find(item => item.available);
        if (!variant || selected.size || !section.isConnected) return;
        selected.set(String(data.productId), { ...data, variant });
        render();
        announce(data.title + ' selected. Choose one more watch to complete your pair.');
      } catch {
        announce('Choose your watches from the available collection below.');
      }
    };
    void preselect();
  };
  document.querySelectorAll('[data-final-set-root]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-final-set-root]').forEach(init));
})();
